import React, { useEffect, useState } from 'react'
import styles from './Notification.module.css'

export interface NotificationProps {
  type: 'success' | 'error'
  message: string
  onViewGroceryList?: () => void
  onStayHere?: () => void
  onClose?: () => void
  autoDismiss?: boolean
  autoDismissDelay?: number
}

export const Notification: React.FC<NotificationProps> = ({
  type,
  message,
  onViewGroceryList,
  onStayHere,
  onClose,
  autoDismiss = true,
  autoDismissDelay = 5000
}) => {
  const [isVisible, setIsVisible] = useState(true)
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    if (autoDismiss) {
      const timer = setTimeout(() => {
        handleClose()
      }, autoDismissDelay)

      return () => clearTimeout(timer)
    }
  }, [autoDismiss, autoDismissDelay])

  const handleClose = () => {
    setIsAnimating(true)
    setTimeout(() => {
      setIsVisible(false)
      onClose?.()
    }, 300) // Match CSS transition duration
  }

  const handleViewGroceryList = () => {
    onViewGroceryList?.()
    handleClose()
  }

  const handleStayHere = () => {
    onStayHere?.()
    handleClose()
  }

  if (!isVisible) return null

  return (
    <div className={`${styles.notification} ${styles[type]} ${isAnimating ? styles.slidingOut : styles.slidingIn}`}>
      <div className={styles.content}>
        <div className={styles.icon}>
          {type === 'success' ? (
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
            </svg>
          )}
        </div>
        
        <div className={styles.message}>
          <h3 className={styles.title}>
            {type === 'success' ? 'Success!' : 'Error'}
          </h3>
          <p>{message}</p>
        </div>

        <button className={styles.closeButton} onClick={handleClose}>
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
          </svg>
        </button>
      </div>

      {(onViewGroceryList || onStayHere) && (
        <div className={styles.actions}>
          {onViewGroceryList && (
            <button 
              className={`${styles.actionButton} ${styles.primary}`}
              onClick={handleViewGroceryList}
            >
              View Grocery List
            </button>
          )}
          {onStayHere && (
            <button 
              className={`${styles.actionButton} ${styles.secondary}`}
              onClick={handleStayHere}
            >
              Stay Here
            </button>
          )}
        </div>
      )}
    </div>
  )
}
